__turbopack_context__.v({
  "buttonsWrapper": "MsdsCq_buttonsWrapper",
  "textInput": "MsdsCq_textInput",
});
